import { Card, Grid, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { UserPermissions } from "generated/graphql";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import CompaniesList from "modules/companies/CompaniesList/CompaniesList";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function CompaniesPage() {
  const { hasPermissions } = useCheckPermissions();
  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                display="flex"
                alignItems="center"
                width="100%"
                justifyContent="space-between"
              >
                <MDTypography variant="h4" fontWeight="medium">
                  Contacts
                </MDTypography>
                {hasPermissions(UserPermissions.MANAGE_COMPANIES) && (
                  <MDTypography as={Link} to={getRoute("companies.create")}>
                    <MDButton color="blue">
                      <Icon>add</Icon>&nbsp; Create Contact
                    </MDButton>
                  </MDTypography>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CompaniesList />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
